import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { FAQS } from '../mock';

const FAQ = () => {
  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0d3d5e]">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Quick answers to common questions about our refrigerated transport
            services.
          </p>
        </div>

        <div className="mt-10 bg-white rounded-lg shadow-sm border border-slate-100 px-6">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((faq, idx) => (
              <AccordionItem
                key={faq.q}
                value={`item-${idx}`}
                className="border-slate-100"
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-[#0d3d5e] hover:no-underline py-5">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-sm md:text-base leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
